import { Link } from "react-router-dom";
import { RadialBarChart, RadialBar, PolarAngleAxis } from "recharts";

const STATUS_META = {
  target_met: { label: "TARGET MET", color: "#5E8467" },
  on_track: { label: "ON TRACK", color: "#C15A38" },
  at_risk: { label: "AT RISK", color: "#B24B3E" },
};

export default function Act60Gauge({ act60 }) {
  const comp = act60?.computed;
  const target = comp?.target || 183;
  const hasData = !!comp && (comp.anchor_days !== null && comp.anchor_days !== undefined || comp.engine_days > 0);
  const total = hasData ? comp.total : null;
  const pct = hasData ? Math.min(100, (total / target) * 100) : 0;

  const meta = hasData ? STATUS_META[comp.status] : { label: "NO DATA", color: "#6F655C" };

  return (
    <div className="rounded-card border border-hairline bg-surface h-full flex flex-col" data-testid="act60-gauge">
      <div className="px-6 pt-6 flex items-start justify-between">
        <div>
          <p className="label-tag mb-1">Act 60 · Physical presence</p>
          <Link to="/insights/presence" className="font-mono text-[10px] font-semibold uppercase tracking-wider text-ember hover:underline" data-testid="act60-details-link">
            Details →
          </Link>
        </div>
        <span className="font-mono text-[10px] font-semibold tracking-[0.15em] px-2 py-1" style={{ color: meta.color, border: `1px solid ${meta.color}` }} data-testid="act60-status">
          {meta.label}
        </span>
      </div>

      <div className="relative flex-1 flex items-center justify-center min-h-[180px]">
        <RadialBarChart
          width={220}
          height={180}
          cx={110}
          cy={105}
          innerRadius={72}
          outerRadius={92}
          startAngle={215}
          endAngle={-35}
          data={[{ value: pct, fill: meta.color === "#6F655C" ? "#E4DDD1" : meta.color }]}
        >
          <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
          <RadialBar dataKey="value" background={{ fill: "#F4F4F5" }} cornerRadius={0} isAnimationActive />
        </RadialBarChart>
        <div className="absolute inset-0 flex flex-col items-center justify-center pt-4 pointer-events-none">
          <p className="font-mono text-4xl font-semibold text-sand-950 leading-none" data-testid="act60-days">
            {hasData ? total : "—"}
          </p>
          <p className="font-mono text-xs text-sand-500 mt-1">/ {target} days</p>
        </div>
      </div>

      {hasData ? (
        <div className="grid grid-cols-3 border-t border-sand-200 divide-x divide-sand-200">
          <div className="px-4 py-3">
            <p className="label-tag text-[9px] mb-1">Needed</p>
            <p className="font-mono text-sm text-sand-900" data-testid="act60-needed">{comp.needed}</p>
          </div>
          <div className="px-4 py-3">
            <p className="label-tag text-[9px] mb-1">Days left</p>
            <p className="font-mono text-sm text-sand-900">{comp.days_left}</p>
          </div>
          <div className="px-4 py-3">
            <p className="label-tag text-[9px] mb-1">Nights PR</p>
            <p className="font-mono text-sm text-sand-900">{comp.nights_pr}</p>
          </div>
        </div>
      ) : (
        <div className="border-t border-sand-200 px-6 py-4">
          <p className="text-xs text-sand-600 mb-2">
            Upload flight history or set a YTD anchor to activate the tracker.
          </p>
          <Link to="/insights/presence" className="font-mono text-xs text-ember font-semibold uppercase tracking-wider hover:underline" data-testid="act60-setup-link">
            Open tracker →
          </Link>
        </div>
      )}
    </div>
  );
}
